import React, { Component } from "react";
import Divider from "@mui/material/Divider";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import Badge from "@mui/material/Badge";
import MessageDetail from "./pageComponents/MessageDetail";
import LoadingCircular from "../LoadingCircular";

class Message extends Component {
  state = {
    messages: [],
    open: false,
    content: "",
    isLoading: false,
  };
  async componentDidMount() {
    const { mobileNumber } = this.props;
    this.setState({ isLoading: true });
    const res = await fetch(`/ng/api/GetMessages/All?User=${mobileNumber}`);
    const data = await res.json();
    this.setState({ messages: data, isLoading: false });
  }
  updateMessageSeen = async (id) => {
    const res = await fetch(`/ng/api/GetMessages/Seen?id=${id}`);
    const data = await res.json();
    const messages = this.state.messages.map((m) =>
      m.Id === id ? { ...m, Seen: true } : m
    );
    this.setState({ messages: messages });
  };
  render() {
    const { messages, isLoading } = this.state;
    return (
      <>
        <LoadingCircular open={isLoading} />
        <MessageDetail
          open={this.state.open}
          onClose={() => {
            this.setState({ open: false });
          }}
          content={this.state.content}
        />
        <Divider sx={{ mt: 1, mb: 1 }}>صندوق پیام</Divider>
        <List>
          {messages.map((message, index) => (
            <React.Fragment key={index}>
              <ListItem
                onClick={() => {
                  if (message.Seen === false) {
                    this.updateMessageSeen(message.Id);
                  }
                  this.setState({ content: message.Body, open: true });
                }}
              >
                <Badge color="success" variant="dot" invisible={message.Seen} />
                <ListItemText
                  primary={message.Subject}
                  secondary={message.DateTime}
                  sx={{ ml: 2 }}
                />
              </ListItem>
              <Divider component="li" />
            </React.Fragment>
          ))}
        </List>
      </>
    );
  }
}

export default Message;
